import useSWR from 'swr';
import type {
  ProductCategoryCondition,
  ProductCategoryConditionOption,
} from '@lambda/apis/src/category/types';

export type ResolvedConditionOption = ProductCategoryConditionOption;

export type ResolvedConditions = ProductCategoryCondition;

/** Callers hand us either the canonical key or a localized name; accept both. */
export const matchesCondition = (
  option: ProductCategoryConditionOption,
  condition: string,
): boolean =>
  [option.key, option.name].some(
    (value) => !!value && value.toLowerCase() === condition.toLowerCase(),
  );

/**
 * `categoryId` is the category's reebeloId. MsCatalog2 resolves copy, labels and images
 * per store, so the payload is rendered as it arrives.
 *
 * Callers map over `options` without guarding it, so a payload that reached here without
 * one is treated as no payload at all — an empty modal rather than a broken page.
 */
export default function useCategoryConditions(
  categoryId: string,
): ResolvedConditions | undefined {
  const { data } = useSWR<ProductCategoryCondition>(
    categoryId ? `/api/conditions/${categoryId}` : null,
  );

  return Array.isArray(data?.options) ? data : undefined;
}
